import "./agencies.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import AgenciesTable from "../../components/agenciesTable/agenciesTable";

const Agencies = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AgenciesTable radiofeeds={false} />
      </div>
    </div>
  );
};

export default Agencies;
